import React from 'react';
import { Card, Row, Col, Typography, List, Tooltip, Divider, Progress } from 'antd';
import { CheckCircleOutlined, CloseCircleOutlined, WarningOutlined, InfoCircleOutlined } from '@ant-design/icons';
import styled from "styled-components";

const {Title, Text, Paragraph } = Typography;

export default function VRTrainingResults({trainingData}) {
   
    const event_results = trainingData;

    const renderEventCard = (event) => {
        const isCompleted = event.time > 0;
        const isOutOfOrder = isCompleted && event.order !== event.expectedOrder;
        let statusColor = '#52c41a'; // Green for success
        let statusIcon = <CheckCircleOutlined />;

        if (event.modifier === 'NOT_REQUIRED') {

        } else if (event.modifier === 'EXCEPTION') {
            statusColor = '#faad14'; // Orange for exceptions
            statusIcon = <WarningOutlined />;
        } else if (!event.success) {
            statusColor = '#f5222d'; // Red for failure
            statusIcon = <CloseCircleOutlined />;
        } else if (isOutOfOrder) {
            statusColor = '#1890ff'; // Blue for out of order
            statusIcon = <InfoCircleOutlined />;
        }

        return (
            <Col key={event.title} xs={24} sm={12} md={8} lg={6}>
                <Tooltip title={`Expected Order: ${event.expectedOrder}, Actual Order: ${event.order}`}>
                    <Card
                        size="small"
                        style={{
                            height: '100%',
                            borderColor: statusColor,
                            opacity: isCompleted ? 1 : 0.6,
                            borderRadius: '16px'
                        }}
                        bodyStyle={{
                            padding: '12px',
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'space-between',
                            height: '100%'
                        }}
                    >
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
                            {statusIcon}
                            {isCompleted && (
                                <Text strong style={{ fontSize: '16px', color: statusColor }}>
                                   {(isOutOfOrder && event.modifier !== "EXCEPTION") && <> <span
                                       style={{textDecoration: "line-through"}}> {event.expectedOrder}</span> | </>} {event.order}
                                </Text>
                            )}
                        </div>
                        <Paragraph strong style={{ marginBottom: '4px' }}>{event.title}</Paragraph>
                        <div>
                            <Text type="secondary" style={{ fontSize: '12px' }}>
                                {event.time > 0 ? `${event.time.toFixed(2)}s` : 'Not Completed'}
                            </Text>
                        </div>
                    </Card>
                </Tooltip>
            </Col>
        );
    };

    return (
        <>
            <Title level={4}>Expanded Detail</Title>
            <Row gutter={[16, 16]}>
                {trainingData.map(renderEventCard)}
            </Row>
        </>
    );
}